import React, { useState } from "react";
import HyroPopper from "@hyro-components/hyro-popper/HyroPopper";
import { useTheme } from "@mui/material/styles";
import { Box, styled } from "@mui/material";

const CopyPopper = ({
  children,
  placement = "top",
  copyLabel = "Copy",
  popperText = "Copied",
  copyText,
  disappearAfter = 500,
  stopPropagation,
  zIndex
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = (e) => {
    stopPropagation && e.stopPropagation();
    navigator.clipboard.writeText(copyText);
    setIsClicked(true);
    setAnchorEl(e.currentTarget);
    setTimeout(() => {
      setAnchorEl(null);
      setIsClicked(false);
    }, disappearAfter + 100);
  };

  const handleMouseEnter = (e) => {
    if (!isClicked) {
      setAnchorEl(e.currentTarget);
    }
  };

  const handleMouseLeave = () => {
    if (!isClicked) {
      setAnchorEl(null);
    }
  };

  return (
    <>
      <Box
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
      </Box>

      {anchorEl && <HyroPopper
        anchorEl={anchorEl}
        placement={placement}
        zIndex={zIndex || theme.zIndex.tooltip + 1}
      >
        <Wrapper>
          {isClicked ? popperText : copyLabel}
        </Wrapper>
      </HyroPopper>
      }
    </>
  );
};

const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: theme.palette.system[700],
  color: theme.palette.system[0],
  fontSize: "11px",
  height: "22px",
  lineHeight: "11px",
  fontWeight: 500,
  borderRadius: "8px",
  padding: "4px 8px"
}));

export default CopyPopper;
